/* eslint-disable import-x/no-default-export */
export default () => [
  {
    country: 'AU',
    hourly: [
      { label: 'AUD 15', value: 15 },
      { label: 'AUD 20', value: 20 },
    ],
    annually: [
      { label: 'AUD 30,000', value: 30000 },
      { label: 'AUD 35,000', value: 35000 },
    ],
  },
  {
    country: 'NZ',
    hourly: [
      { label: 'NZD 15', value: 15 },
      { label: 'NZD 20', value: 20 },
    ],
    annually: [
      { label: 'NZD 30,000', value: 30000 },
      { label: 'NZD 35,000', value: 35000 },
    ],
  },
  {
    country: 'GB',
    hourly: [
      { label: 'GBP 5', value: 5 },
      { label: 'GBP 10', value: 10 },
    ],
    annually: [
      { label: 'GBP 5,000', value: 5000 },
      { label: 'GBP 10,000', value: 10000 },
    ],
  },
];
